/** @typedef {import('../../../shared/AuthProvider/State').default} Response */

import { AuthContext } from '../../../shared/AuthProvider';
import { useContext } from 'react';

/** @returns {Response} */
export default function useAuth() {
	return useContext(AuthContext);
}
